const scheduleAutopaySchema = {
  paymentAccountId: [{
    rule: 'required',
    isValid: (input) => {
      if (!input) {
        return 'The input field is required';
      }
      return true;
    },
  }],
};

export default scheduleAutopaySchema;
